module.exports = __webpack_public_path__ + "static/img/twjd-sde16.0a8b2f8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-sde16.png
// module id = 836
// module chunks = 0